import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-partners">
        <div className="footer-partner-col">
          <img src="/images/pokemon-go-logo.png" alt="Pokémon GO" className="partner-logo" />
          <h3>Pokémon GO</h3>
          <p>{t('partners', 'pokemonText')}</p>
          <p className="partner-code">3DJPT2W38</p>
        </div>
        <div className="footer-partner-col">
          <img src="/images/tubebuddy-logo.png" alt="TubeBuddy" className="partner-logo" />
          <h3>TubeBuddy</h3>
          <p>{t('partners', 'tubeBuddyText')}</p>
          <a
            href="https://www.tubebuddy.com/pricing?a=rgutubebuddy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('partners', 'tubeBuddyLink')}
          </a>
        </div>
        <div className="footer-partner-col">
          <img src="/images/nordvpn-logo.svg" alt="NordVPN" className="partner-logo" />
          <h3>NordVPN</h3>
          <p>{t('partners', 'nordVpnText')}</p>
          <a
            href="https://go.nordvpn.net/aff_c?offer_id=15&aff_id=retrogameup"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('partners', 'nordVpnLink')}
          </a>
        </div>
      </div>

      <div className="footer-copyright">
        <p>{t('footer')}</p>
        <p>
          <Link to="/cookie-policy" className="footer-policy-link">
            {t('cookiePolicyLink')}
          </Link>
          {' · '}
          <Link to="/privacy-policy" className="footer-policy-link">
            {t('privacyPolicyLink')}
          </Link>
          {' · '}
          <a
            href="https://www.youtube.com/@RetroGameUp"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-policy-link"
          >
            @RetroGameUp
          </a>
        </p>
      </div>
    </footer>
  );
}
